import { motion } from "framer-motion";
import { Reveal, SectionHeading } from "./Reveal";
import { PROCESS } from "@/lib/site";

export default function Process() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden" data-testid="process-section">
      <div className="absolute left-1/2 top-1/2 -z-10 h-[500px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-amber-500/[0.05] blur-[140px]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          align="center"
          eyebrow="Our Learning Process"
          title={
            <>
              Learn. Practice. <span className="text-brand">Create. Grow.</span>
            </>
          }
        />

        <div className="relative mt-16">
          {/* Connector line — desktop */}
          <motion.span
            className="absolute top-7 left-[12%] right-[12%] hidden lg:block h-px bg-gradient-to-r from-transparent via-amber-500/60 to-transparent"
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          />
          {/* Connector line — mobile */}
          <motion.span
            className="absolute left-7 top-2 bottom-2 lg:hidden w-px bg-gradient-to-b from-transparent via-amber-500/50 to-transparent"
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          />

          <ol className="grid grid-cols-1 gap-10 lg:grid-cols-4 lg:gap-6">
            {PROCESS.map((step, i) => (
              <Reveal key={step.num} delay={i * 0.15} className="relative">
                <li className="flex gap-6 lg:flex-col lg:gap-0 lg:text-center" data-testid={`process-step-${step.num}`}>
                  <div className="relative z-10 shrink-0">
                    <span className="flex h-14 w-14 items-center justify-center rounded-full border border-amber-500/40 bg-obsidian-card font-display text-sm font-bold text-brand shadow-glow-amber-sm">
                      {step.num}
                    </span>
                  </div>
                  <div className="lg:mt-6">
                    <h3 className="font-display text-xl font-bold uppercase tracking-wide text-white">{step.title}</h3>
                    <p className="mt-2.5 text-sm text-gray-400 leading-relaxed lg:mx-auto lg:max-w-[240px]">{step.desc}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
